export const moods = [
    { id: 28, label: "🔥 Action Packed" },
    { id: 35, label: "😂 Feel‑Good Fun" },
    { id: 18, label: "🎭 Emotional Drama" },
    { id: 10749, label: "❤️ Romantic Vibes" },
    { id: 27, label: "😱 Scary Nights" },
    { id: 878, label: "🚀 Sci‑Fi Worlds" },
    { id: 53, label: "🧠 Mind‑Bending Thrillers" },
  ];
  